import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestsQueryKey } from "../../bond-request/bond-request.keys";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountBondingLineQueryKey, accountQueryKey } from "../account.keys";

export const useAdminUpdateSuretyAccountBondingLine = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { put } = useRequest();

	const mutation = useMutation({
		mutationKey: ["updateSuretyAccountBondingLine", accountId],
		mutationFn: async (data: Dtos.Admin.SuretyAccount.Update.BondingLine.Request) => {
			await put(`/v2/admin/surety/accounts/${accountId}/bonding-line`, data, "none");
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey() }),
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountBondingLineQueryKey(accountId) }),
				queryClient.refetchQueries({ queryKey: accountPreviewsQueryKey() }),
			]);
		},
	});

	return {
		updateSuretyAccountBondingLine: mutation.mutate,
		updateSuretyAccountBondingLineIsLoading: mutation.isPending,
	};
};
